import React from "react";
import { Navigate } from "react-router-dom";

//AuthenticationInner pages
import BasicSignIn from "../pages/AuthenticationInner/Login/BasicSignIn";
import CoverSignIn from "../pages/AuthenticationInner/Login/CoverSignIn";
import BasicSignUp from "../pages/AuthenticationInner/Register/BasicSignUp";
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from "../pages/AuthenticationInner/PasswordReset/BasicPasswReset";
//pages

import CoverPasswReset from "../pages/AuthenticationInner/PasswordReset/CoverPasswReset";
import BasicLockScreen from "../pages/AuthenticationInner/LockScreen/BasicLockScr";
import CoverLockScreen from "../pages/AuthenticationInner/LockScreen/CoverLockScr";
import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";
import BasicSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg";
import CoverSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg";
import BasicTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify";
import CoverTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

//APi Key
import APIKey from "../pages/APIKey/index";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

import ProductList from "../pages/OwnComponents/Product/ProductList";
import ProductTypeList from "../pages/OwnComponents/ProductTypes/ProductTypeList";
import CustomerList from "../pages/OwnComponents/Customers/CustomerList";
import UserList from "../pages/OwnComponents/User/UserList";
import OrderList from "../pages/OwnComponents/Order/OrderList";
import OrderProductList from "../pages/OwnComponents/Order/OrderProductList";
import SpeechRecognition from "../pages/OwnComponents/Speech";
import PersonalDetailsList from "../pages/OwnComponents/PersonalDetails/PersonalDetailsList";
import OrderReport from "../pages/OwnComponents/Reports/OrderReport";
import LedgersList from "../pages/OwnComponents/Reports/Ledgers/LedgersList";
import LedgersDetails from "../pages/OwnComponents/Reports/Ledgers/LedgersDetails";
import ProductTypeWithOutHUID from "../pages/OwnComponents/NewProductTypes/ProductTypeWithOutHUID";
import CredentialError from "../pages/OwnComponents/AuthenticationError/CredentialError";
import AccountExpired from "../pages/OwnComponents/AuthenticationError/AccountExpired";
import StocksMovingHistoryList from "../pages/OwnComponents/ProductTypes/StocksMovingHistory";
import ProductTypeWithOutHUIDBasePage from "../pages/OwnComponents/NewProductTypes/ProductTypeWithHUIDBasePage";

const authProtectedRoutes = [
  { path: "/product-list", component: <ProductList /> },
  { path: "/productType-list", component: <ProductTypeList /> },
  { path: "/move-stock-history", component: <StocksMovingHistoryList /> },
  {
    path: "/productTypeWithOutHUID-list/:model_name",
    component: <ProductTypeWithOutHUID />,
  },
  {
    path: "/productTypeWithOutHUIDBasePage-list",
    component: <ProductTypeWithOutHUIDBasePage />,
  },
  { path: "/customer-list", component: <CustomerList /> },
  { path: "/user-list", component: <UserList /> },
  { path: "/order-list", component: <OrderList /> },
  { path: "/order-product/:orderId", component: <OrderProductList /> },
  { path: "/speech", component: <SpeechRecognition /> },
  { path: "/personalDetails-list", component: <PersonalDetailsList /> },
  { path: "/order-report", component: <OrderReport /> },
  { path: "/ledgers-report", component: <LedgersList /> },
  { path: "/ledgers/:customerID", component: <LedgersDetails /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/productType-list" />,
  },
  { path: "*", component: <Navigate to="/productType-list" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/credential-error", component: <CredentialError /> },
  { path: "/account-expired", component: <AccountExpired /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-signup-basic", component: <BasicSignUp /> },
  { path: "/auth-signup-cover", component: <CoverSignUp /> },
  { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },

  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },
  { path: "*", component: <Login /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/login" />,
  },
];

export { authProtectedRoutes, publicRoutes };
